import React, { Fragment } from 'react';
import moment from 'moment';
// import { string, bool } from 'prop-types';

const calculateTime = (time, isShowTime) => {
  if (!time) return 'Today';
  const curTime = moment();
  const inputTime = moment(time);
  const diffDate = moment(inputTime).startOf('date').diff(curTime.startOf('date'), 'days');

  if (diffDate === 0) {
    return isShowTime ? inputTime.format('hh:mm A') : 'Today';
  }

  if (diffDate === -1) return 'Yesterday';

  const isSameWeek = Math.abs(diffDate) < 7;
  if (isSameWeek) {
    return inputTime.format('ddd');
  }

  const isSameYear = curTime.isSame(inputTime, 'year');
  if (isSameYear) {
    return inputTime.format('DD MMM');
  }

  return inputTime.format('DD MMM YYYY');
};

const TimeStamp = ({ time, isShowTime }) => (
  <Fragment>
    {calculateTime(time, isShowTime)}
  </Fragment>
);

TimeStamp.propTypes = {
  // time: string,
  // isShowTime: bool,
};
TimeStamp.defaultProps = {
  // time: '',
  // isShowTime: false,
};

export default TimeStamp;
